<template>
  <sModal
    v-model="mutableShow"
    :mask-closable="false"
    :title="$t('OrgSettings.CopySettings')"
    @close="closeModal">
    <sAlert
      v-if="mutableShow"
      class="mb-5"
      show-icon>
      <template v-if="mode === 'all'">
        {{ $t('OrgSettings.CopyAllSettings') }}
      </template>
      <template v-else-if="mode === 'one' || mode === 'choise'">
        {{ $t('Menu.OrganizerSettings') }}
      </template>
      <template slot="desc">
        <template v-if="mode === 'all'">
          <div>{{ $t('OrgSettings.CopyAllSettingsToOtherOrg') }}</div>
          <b>{{ $t('OrgSettings.OtherSettingsDeleted') }}</b>
        </template>
        <div v-else-if="mode === 'one'">
          {{ copyProps.settingInfo.settingTitle }}
        </div>
        <div v-else-if="mode === 'choise'">
          <ul
            v-for="setting in copyProps.slice(0, 2)"
            :key="setting.settingId">
            <li>{{ setting.settingTitle }}</li>
          </ul>
          <span
            v-if="copyProps.length > 2">
            ...{{ $t('Purchasing.More') }}: {{ copyProps.length - 2 }}</span>
        </div>
      </template>
    </sAlert>
    <sForm
      v-if="model && mutableShow"
      id="copy-settings-form"
      ref="formCopy"
      :disabled="loading"
      label-position="top"
      :model="model"
      :rules="rulesCopySetting">
      <sFormItem
        :label="$t('OrgSettings.CopyFromOrganization')"
        prop="fromOrganizationId">
        <sInput
          v-if="organization && organization.title"
          readonly
          :value="organization.title"/>
        <OrganizersSelect
          v-else
          ref="organizers"
          v-model="model.fromOrganizationId"
          class="width-100"
          :disabled="loading"
          @on-change="handleOrganization($event, 'fromOrganizationId')"/>
      </sFormItem>
      <sFormItem
        class="mt-5"
        :label="$t('OrgSettings.CopyToOrganization')"
        prop="toOrganizationId">
        <OrganizersSelect
          ref="organizers"
          v-model="model.toOrganizationId"
          class="width-100"
          :disabled="loading"
          @on-change="handleOrganization($event, 'toOrganizationId')"/>
      </sFormItem>
    </sForm>
    <div
      key="footer"
      slot="footer">
      <sButton
        data-qa="btn-apply"
        :disabled="loading"
        @click="handleSubmit">
        {{ $t('Common.Copy') }}
      </sButton>
      <sButton
        data-qa="btn-close"
        :disabled="loading"
        type="text"
        @click="closeModal">
        {{ $t('Common.Close') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
import OrganizersSelect from 'components/organizer-settings/OrganizersSelect.vue'

import OrganizerSettingApi from '@/api/organizerSettingApi'
const organizer_setting_api = new OrganizerSettingApi()

export default {
  name: 'organizerSettingCopy',
  data() {
    const that = this
    return {
      fromOrganizationId: null,
      toOrganizationId: null,
      rulesCopySetting: {
        fromOrganizationId: [
          {
            required: true,
            trigger: 'change',
            validator(rule, value, callback) {
              if (!value) {
                callback(new Error(that.$t('OrgSettings.ChoiseOrgFrom')))
              }
              callback()
            },
          }
        ],
        toOrganizationId: [
          {
            required: true,
            trigger: 'change',
            validator(rule, value, callback) {
              if (!value) {
                callback(new Error(that.$t('OrgSettings.ChoiseOrgTo')))
              }
              if (value === that.model.fromOrganizationId) {
                callback(new Error(that.$t('OrgSettings.ChoiseToOtherOrg')))
              }
              callback()
            },
          }
        ]
      },
    }
  },
  methods: {
    closeModal() {
      this.fromOrganizationId = null
      this.toOrganizationId = null
      this.$emit('close')
      this.mutableShow = false
    },
    handleOrganization(val, prop) {
      this[prop] = val.organizationId
    },
    async handleSubmit() {
      this.$emit('update:loading', true)
      this.$refs.formCopy.validate(async (valid) => {
        if ( !valid ) {
          this.$emit('update:loading', false)
          return
        }
        let apiName = 'copyOrganizationSetting'

        if (this.mode !== 'one') {
          apiName = 'copyOrganizationSettings'
        }
        await organizer_setting_api[apiName](this.model)
          .then(res => {
            if ((this.mode !== 'one' && res) || (this.mode === 'one' && res?.success)) {
              this.$emit('success', this.model)
              this.$nextTick(() => {
                this.closeModal()
              })
            } else {
              this.$notice.warning({
                title: this.$t('Common.ErrorTitle'),
                message: this.$t(`OrgSettings.Errors.${res?.message}`),
                duration: 10,
              })
            }
          }).catch(async (error) => {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: error,
              duration: 10,
            })
          })
          .finally(() => (
            this.$emit('update:loading', false)
          ))
      })
    },
  },
  computed: {
    mutableShow: {
      get() {
        return this.show
      },
      set(newValue) {
        this.$emit('update:show', newValue)
      }
    },
    model: {
      get() {
        if (this.mode === 'one') {
          return {
            fromOrganizationId: this.organization.organizationId,
            settingOrganizationId: this.copyProps.settingOrganizationId,
            toOrganizationId: this.toOrganizationId
          }
        } else if (this.mode === 'all') {
          return {
            fromOrganizationId: this.fromOrganizationId,
            toOrganizationId: this.toOrganizationId
          }
        } else if (this.mode === 'choise') {
          return {
            fromOrganizationId: this.organization.organizationId,
            toOrganizationId: this.toOrganizationId,
            settingsIds: this.copyProps.map(i => i.settingId)
          }
        }
        return this.value
      }
    }
  },
  props: {
    mode: {
      type: String,
      validator: function (value) {
        const correct = ['one', 'all', 'choise'].indexOf(value) !== -1
        return correct
      },
      default: 'one'
    },
    /**
     * Данные организации откуда копируем
     * {
     *    organizationId
     *    title
     * }
     */
    organization: {
      type: Object
    },
    /**
     * Данные настройки/настроек
     */
    copyProps: {
      type: [Object, Array]
    },
    loading: {
      type: Boolean
    },
    show: {
      type: Boolean
    },
  },
  components: {
    OrganizersSelect
  }
}
</script>
